import SvgIcon from '@mui/material/SvgIcon';

import type { SvgIconProps } from '@mui/material';

export const GreenCheckIcon = (props: SvgIconProps) => (
    <SvgIcon {...props} fill="none" viewBox="0 0 16 12" xmlns="http://www.w3.org/2000/svg">
        <path d="M15.601.52a1 1 0 0 0-1.414 0L5.348 9.359 1.813 5.823A1 1 0 1 0 .398 7.237l4.243 4.243a1 1 0 0 0 1.414 0l9.546-9.546a1 1 0 0 0 0-1.414Z" fill="#00B579" />
    </SvgIcon>
);
